<template>

<div>

    <div id="modal_voucher_form" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" v-if="activeVoucher == 'new'">Skapa ny kupong</h4>
                    <h4 class="modal-title" v-else>Ändra kupong</h4>
                </div>
                <div class="modal-body">

                    <div class="form-group" :class="{ 'has-error': getError('valid_to')}">
                        <label class="control-label">Gäller till</label>
                        <datepicker
                            language="sv"
                            input-class="form-control"
                            v-on:selected="selectDate"
                            :format="date_format"
                            :value="date_start">
                        </datepicker>
                    </div>

                    <div class="form-group" :class="{ 'has-error': getError('value_total')}">
                        <label class="control-label">Belopp</label>
                        <input type="number" class="form-control" v-model="card.value_total" />
                    </div>

                    <div class="form-group">
                        <label class="control-label">Ordernummer</label>
                        <input type="text" class="form-control" v-model="card.order_number" />
                    </div>

                    <div class="form-group">
                        <label class="control-label">Ref nr eller annat som ska anges på fakturan</label>
                        <input type="text" class="form-control" v-model="card.reference" />
                    </div>

                    <div class="form-group">
                        <label class="control-label">Text</label>
                        <input type="text" class="form-control" v-model="card.text" />
                    </div>

                    <div class="form-group" v-if="activeVoucher == 'new'">
                        <input type="checkbox" id="checkbox_send_mail" value="1" :disabled="!customer.email" v-model="card.send_mail" />
                        <label class="control-label" for="checkbox_send_mail">Skicka e-post</label>
                    </div>

                    <div class="alert alert-warning" v-show="Object.keys(former.errors).length > 0">
                        Du måste fylla i alla rödmarkerade fält.
                    </div>

                    <div class="alert alert-danger" v-show="unhandled_error_message">
                        {{ unhandled_error_message }}
                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-info" data-dismiss="modal">Avbryt</button>

                    <button
                        type="button"
                        class="btn btn-primary"
                        :disabled="poster.submitted"
                        @click="posterPost()"
                        v-if="activeVoucher === 'new'"
                    >
                        Spara
                    </button>

                    <button
                        type="button"
                        class="btn btn-primary"
                        :disabled="patcher.submitted"
                        @click="patcherPatch()"
                        v-if="activeVoucher !== 'new'"
                    >
                        Spara
                    </button>

                </div>

            </div>
        </div>
    </div>

</div>

</template>

<script>

import patcher from '../../shared/mixins/patcher'
import poster from '../../shared/mixins/poster'

export default {

    mixins: [
        patcher,
        poster
    ],

    props: {
        activeVoucher: {
            required: true
        },
        customer: {
            required: true
        }
    },

    data () {
        return {
            date_format: 'yyyy-MM-dd',
            date_init: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            date_start: this.date_init,

            validationError: false,
            errors: {},

            unhandled_error_message: '',

            card: {
                id: 0,
                valid_to: null,
                value_total: null,
                order_number: null,
                text: null,
                reference: null,
                send_mail: true
            }
        }
    },

    computed: {
        posterUrl () {
            return '/customers/' + this.customer.id + '/vouchers'
        },
        posterData () {
            return this.card
        },
        patcherUrl () {
            return '/customers/' + this.customer.id + '/vouchers/' + this.card.id
        },
        patcherData () {
            return this.card
        }
    },

    methods: {

        posterSuccess () {
            if (this.card.send_mail === true) {
                bus.$emit('notify', 'Kupongen skapad och sms/mail skickat till kund.')
            } else {
                bus.$emit('notify', 'Kupongen skapad och sms skickat till kund.')
            }

            $('#modal_voucher_form').modal('hide')

            this.$emit('refresh')
        },

        patcherSuccess () {
            bus.$emit('notify', 'Kupongen uppdaterades')

            $('#modal_voucher_form').modal('hide')

            this.$emit('refresh')
        },

        posterFail (response) {
            if (response.data && response.status !== 422) {
                this.unhandled_error_message = response.data.message
            }
        },

        patcherFail (response) {
            if (response.data && response.status !== 422) {
                this.unhandled_error_message = response.data.message
            }
        },

        selectDate (test) {
            console.log('date changed')
            console.log(test)

            console.log('moment date')
            console.log(moment(test).format('YYYY-MM-DD'))

            this.card.valid_to = moment(test).format('YYYY-MM-DD')
        }

    },

    watch: {
        activeVoucher (data) {
            console.log('date init')
            console.log(this.date_init)

            this.former.errors = {}
            this.unhandled_error_message = ''

            if (data != 'new') {
                this.date_start = moment(data.valid_to).toDate()

                this.card.id = data.id
                this.card.value_total = data.value_total
                this.card.order_number = data.order_number
                this.card.text = data.text
                this.card.reference = data.reference
                this.card.valid_to = moment(data.valid_to).format('YYYY-MM-DD')
            } else {
                console.log('new voucher init')

                this.date_start = moment(this.date_init).toDate()

                this.card.id = 0
                this.card.value_total = ''
                this.card.order_number = ''
                this.card.text = ''
                this.card.reference = ''
                this.card.valid_to = moment(this.date_init).format('YYYY-MM-DD')
                //this.card.send_mail = (!this.customer.phone && this.customer.email ? true : null)
                this.card.send_mail = true
            }
        }
    }

}
</script>
